var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActionEmailSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 5.83203L8.47077 10.5949C9.02174 10.9806 9.29723 11.1734 9.59689 11.2481C9.86158 11.3141 10.1384 11.3141 10.4031 11.2481C10.7028 11.1734 10.9783 10.9806 11.5292 10.5949L18.3333 5.83203M5.66667 16.6654H14.3333C15.7335 16.6654 16.4335 16.6654 16.9683 16.3929C17.4387 16.1532 17.8212 15.7707 18.0608 15.3003C18.3333 14.7656 18.3333 14.0655 18.3333 12.6654V7.33203C18.3333 5.9319 18.3333 5.23183 18.0608 4.69705C17.8212 4.22665 17.4387 3.8442 16.9683 3.60451C16.4335 3.33203 15.7335 3.33203 14.3333 3.33203H5.66667C4.26654 3.33203 3.56647 3.33203 3.03169 3.60451C2.56129 3.8442 2.17883 4.22665 1.93915 4.69705C1.66667 5.23183 1.66667 5.9319 1.66667 7.33203V12.6654C1.66667 14.0655 1.66667 14.7656 1.93915 15.3003C2.17883 15.7707 2.56129 16.1532 3.03169 16.3929C3.56647 16.6654 4.26654 16.6654 5.66667 16.6654Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionEmailSend);
export default __webpack_public_path__ + "static/media/action-email-send.f2729da6abdb9e42d59e6d56712926f1.svg";
export { ForwardRef as ReactComponent };